import { APIClient } from '@frontend/api-utils';

export class LabelTemplateJsonClient extends APIClient {
    public static readonly endpoint = '/label-api/json/v1';

    public static async fetchLabelTemplateJson(accountId: string) {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/templates`);
        return await this.handleBlobResponse(response);
    }

    public static async postLabelTemplateJson(accountId: string, file: File) {
        const formData = new FormData();
        formData.append('file', file);

        const response = await this.post(`${this.endpoint}/accounts/${accountId}/templates`, formData);
        return await this.handleBlobResponse(response);
    }
}
